import React from 'react'
import {Link} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { updateBreadcrumb } from './store/breadcrumbSlice'
import { updateIntent } from './store/intentSlice'

const ContactBreadCrumbs = (props) => {
  const dispatch = useDispatch()
  const breadcrumbs = ['describe', 'review', 'options', 'connect']
  const breadCrumbStatus = useSelector((state) => state.breadcrumb.value)

  const updateBreadCrumb = (breadcrumb) => {
    dispatch(updateBreadcrumb(breadcrumb))
    if (breadcrumb === "describe") { 
      dispatch(updateIntent(""));
    }
  }

  const createBreadCrumbLink = (breadcrumb) => {
    const relativeUrl = props.relativeUrl
    if (breadcrumb === "options") {
      return relativeUrl+"/options"
    } else {
      return relativeUrl+"/"
    } 
  }

  return (
    <div id="contact-breadcrumbs">
      {breadcrumbs.map((breadcrumb, i) => {
        const lastEntryInArr = (breadcrumbs.length-1 === i);
        let statusClass = "grey";
        if (breadcrumbs.indexOf(breadCrumbStatus) === i) {
          statusClass = "blue"
        }
        if (breadcrumbs.indexOf(breadCrumbStatus) > i) {
          statusClass = "green"
        }

        return (
          <div className="contact-icon-bar" key={i}>
            {statusClass === "green" ?
              (<Link to={createBreadCrumbLink(breadcrumb)} onClick={() => updateBreadCrumb(breadcrumb)}>
                <div className={`contact-icon ${statusClass}`}>
                  <div className="contact-icon-circle">
                    <div className="contact-icon-tick"/>
                  </div>
                </div>
              </Link>) :
              (<div className={`contact-icon ${statusClass}`}>
                <div className="contact-icon-circle">
                  <div className="contact-icon-tick"/>
                </div>
              </div>)}
          {!lastEntryInArr && <div className={`contact-icon-line ${statusClass}`}/>}
        </div>
        )
      })}

      <div className="contact-icon-text-row">
        {breadcrumbs.map((breadcrumb, i) => {
          let statusClass = "grey";
          if (breadcrumbs.indexOf(breadCrumbStatus) === i) {
            statusClass = "blue"
          }
          if (breadcrumbs.indexOf(breadCrumbStatus) > i) {
            statusClass = "green"
          }

          if (statusClass === "green") {
            return (
              <div className={`contact-icon-text ${statusClass}`} key={i}>
                <Link to={createBreadCrumbLink(breadcrumb)} onClick={() => updateBreadCrumb(breadcrumb)}>
                  {props.contentStrings[`breadcrumb-${breadcrumb}`]}
                </Link>
              </div>
            )
          } else {
            return (
              <div className={`contact-icon-text ${statusClass}`} key={i}>{props.contentStrings[`breadcrumb-${breadcrumb}`]}</div>
            )
          }
        })}
      </div>
    </div>
  )
}

export default ContactBreadCrumbs